import { render } from "./GoingToBuilding.vue?vue&type=template&id=460241d2"
import script from "./GoingToBuilding.vue?vue&type=script&lang=js"
export * from "./GoingToBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__